import React from 'react';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { useCrmHostUrlContext } from '../../../components/resource-redirect/crm-host-url-context';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, casesTabLabel, casesTabPathName } from '../admin-area-pathnames';
import { useTenantAddons } from '../../../components/tenant-addons';
import { caseClosureReasonPathName, caseContactReasonPathName, caseGroupPathName, associateUserRolePathName, caseTypePathName, caseRestrictionPathName } from './cases-pathnames';

export function CasesMenu() {
  const { url } = useCrmHostUrlContext();

  const { isTenantAddonEnabled } = useTenantAddons();
  const canAdminConfidentialCases = isTenantAddonEnabled(['ConfidentialCases']);

  function handleClick(entityName: string) {
    const link = `${url}/main.aspx?etn=${entityName}&pagetype=entitylist`;
    window.open(link);
  }
  return (
    <Restricted actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, casesTabPathName)}>{casesTabLabel}</AdminHeaderLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, casesTabPathName, caseClosureReasonPathName)}>Afslutningsårsager</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, casesTabPathName, caseContactReasonPathName)}>Henvendelsesårsager</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, casesTabPathName, caseGroupPathName)}>Sagsgrupper</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, casesTabPathName, caseTypePathName)}>Sagstyper</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, casesTabPathName, associateUserRolePathName)}>Roller for supplerende sagsbehandler</AdminRouterLink>
      {canAdminConfidentialCases && <AdminRouterLink to={joinURL('/', adminAreaPathName, casesTabPathName, caseRestrictionPathName)}>Sagsafskærmninger</AdminRouterLink>}
    </Restricted>
  );
}
